import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../commons/Loading';
import { useAlert } from 'react-alert';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import axios from 'axios';
import { useAuth } from '../../commons/Auth';
import SignalsPresentational from './SignalsPresentational';
import './ProfileDetail.scss';
import './TabsProfile.scss';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const SignalsResume = ({ profile, location, match }) => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();

  const [signals, setSignals] = useState([]);
  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    signalman: withDefault(StringParam, ''),
    commercial: withDefault(StringParam, ''),
    admin: withDefault(StringParam, ''),
    condo: withDefault(StringParam, ''),
    year: NumberParam,
    accountabilityMonth: NumberParam,
    notes: withDefault(StringParam, ''),
    signalTypeCode: withDefault(StringParam, 'CONDO'),
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
  });

  const {
    signalman,
    commercial,
    admin,
    condo,
    year,
    notes,
    accountabilityMonth,
    signalTypeCode,
    limit,
    offset,
  } = query;

  function onFilter(queryDiff) {
    if (
      (queryDiff.signalman && queryDiff.signalman !== signalman) ||
      (signalman && queryDiff.signalman === '') ||
      (queryDiff.commercial && queryDiff.commercial !== commercial) ||
      (commercial && queryDiff.commercial === '') ||
      (queryDiff.admin && queryDiff.admin !== admin) ||
      (admin && queryDiff.admin === '') ||
      (queryDiff.notes && queryDiff.notes !== notes) ||
      (notes && queryDiff.notes === '') ||
      (queryDiff.condo && queryDiff.condo !== condo) ||
      (condo && queryDiff.condo === '') ||
      (queryDiff.year && queryDiff.year !== year) ||
      (year && queryDiff.year === '') ||
      (queryDiff.accountabilityMonth &&
        queryDiff.accountabilityMonth !== accountabilityMonth) ||
      (accountabilityMonth && queryDiff.accountabilityMonth === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  const fetchSignals = async () => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/signals/admin`,
      {
        headers: { Authorization: newToken },
        params: {
          signalman,
          commercial,
          admin,
          notes,
          condo,
          year,
          accountabilityMonth,
          signalTypeCode,
          limit,
          offset,
        },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [], headers = {} } = response;
    setSignals(data.signals || []);
    setTotal(+headers['x-total-count']);
  };

  useEffect(() => {
    fetchSignals();
  }, [
    signalman,
    commercial,
    admin,
    notes,
    condo,
    year,
    accountabilityMonth,
    signalTypeCode,
    limit,
    offset,
  ]);

  return (
    <SignalsPresentational
      data={signals}
      profile={profile}
      newIsAdmin={newIsAdmin}
      query={query}
      total={total}
      onFilter={onFilter}
      location={location}
      match={match}
      setQuery={setQuery}
    />
  );
};

export default SignalsResume;
